import { batch } from 'react-redux'
import _ from 'lodash'
import { NvApi } from '@nv/react-commons/src/Services'
import countryUtils from '@nv/react-commons/src/Utils/CountryUtils'
import { dashApi } from 'services/api'
import { INVALID_REGISTER, LITE_REGISTER } from 'utils/GoogleAnalytics/events'
import { mapShippers } from 'containers/LoginForm/saga'
import { shipperCreators, userCreators } from 'containers/Base/redux'
import { DEFAULT_LOCALE } from 'containers/Base/constants'
import { languageCreators } from 'containers/LanguageProvider/redux'
import { getLocale } from 'utils/locale'
import { trackEvent } from 'utils/GoogleAnalytics/GAEventTracker'
import { mixpanelTrackSignUpDetails, mixpanelTrackSignUpSubmitted } from 'components/Mixpanel/helpers'
import { SIGN_UP_DATA_LOCAL_STORAGE_KEY } from '../SignUpWrapper/SignUpWrapper.constants'
import { SignUpDataType } from '../SignUpWrapper/SignUpWrapper.interface'
import { COUNTRIES } from '@nv/react-commons/src/Constants'
import { getTermsOfUseLink, getWebsiteContactUsLink } from 'utils/website'

type registerArgs = {
  dispatch: (action: unknown) => void
  payload: any
}

export const register = async ({ dispatch, payload }: registerArgs) => {
  const response = await dashApi.registerV2(payload)

  const user = response.data
  const shippers = mapShippers(user)

  mixpanelTrackSignUpSubmitted(payload.email ? 'email' : 'phone')
  mixpanelTrackSignUpDetails(user)

  if (!response.ok) {
    trackEvent(INVALID_REGISTER)
    return response
  }

  trackEvent({
    action: LITE_REGISTER.action + countryUtils.getCountryNames(user?.shippers[0]?.country),
    label: LITE_REGISTER.label
  })

  NvApi.setAuthToken(user.accessToken)
  const locale = user?.locale || DEFAULT_LOCALE
  NvApi.setLanguage(locale)

  batch(() => {
    dispatch(userCreators.signUpSetupPending())
    dispatch(shipperCreators.getShipperSuccess(shippers))
    dispatch(languageCreators.changeLocale(getLocale(locale)))
    dispatch(shipperCreators.selectShipper(user.defaultShipperId))
    dispatch(userCreators.signUpSuccess(_.omit(user, 'shippers')))
  })

  return { ok: true }
}

export const openTermsOfUseLink = () => {
  let link = getTermsOfUseLink(COUNTRIES.SG)
  try {
    const signUpData: SignUpDataType = JSON.parse(sessionStorage.getItem(SIGN_UP_DATA_LOCAL_STORAGE_KEY))
    if (signUpData.country) {
      link = getTermsOfUseLink(signUpData.country?.toLowerCase())
    }
  } catch (e) {}
  window.open(link, '_blank').opener = null
}

export const openWebsiteContactUsLink = () => {
  let link = getWebsiteContactUsLink(COUNTRIES.SG)
  try {
    const signUpData: SignUpDataType = JSON.parse(sessionStorage.getItem(SIGN_UP_DATA_LOCAL_STORAGE_KEY))
    if (signUpData.country) {
      link = getWebsiteContactUsLink(signUpData.country?.toLowerCase())
    }
  } catch (e) {}
  window.open(link, '_blank').opener = null
}
